/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Contract, utils } from "ethers";
var _abi = [
    {
        inputs: [
            {
                internalType: "bytes4",
                name: "interfaceId",
                type: "bytes4",
            },
        ],
        name: "supportsInterface",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var IERC165__factory = /** @class */ (function () {
    function IERC165__factory() {
    }
    IERC165__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    IERC165__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    IERC165__factory.abi = _abi;
    return IERC165__factory;
}());
export { IERC165__factory };
